<template>
    <div v-if="user" class="avatar-upload">
        <label>
            <span>Upload Avatar</span>
            <div class="avatar-upload-field">
                <input class="hidden-file-input" type="file" @change="uploadImage($event)">
                <img :src="user.avatar" :alt="user.name">
                <span>Edit</span>
            </div>
        </label>
    </div>
</template>

<script>
    import UserResource from "../../ApiResources/UserResource";

    export default {
        name: "AvatarUpload",
        props: {
            user: {}
        },

        methods: {
            uploadImage($event) {
                new UserResource()
                    .updateUserAvatar(this.user.id, $event.target.files[0])
                    .then(() => this.$emit('updated'));
            }
        },
    }
</script>

<style lang="scss" scoped>
    
</style>